import React from 'react';
import {
  Text,
  Button,
  Flex,
  useToast,
  Tr,
  Td,
  Select,
  Spacer,
  Tooltip,
} from '@chakra-ui/react';
import style from '../components/common/style';
import { ChecktableTwo } from '../components/common/ChecktableTwo';
import { TableComp } from '../components/common/table';
import { useHistory } from 'react-router-dom';
import { options } from '../context/data';
import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import { listStoreManagement, colStoreManagement } from '../context/data';
import { customInputLabel } from '../components/createAppVersionComponent/createAppVersionComponent';
import { MiniHeader } from '../components/common/customComponent';
import ApiManager from '../config/apiManager';
import LangContext from '../context/languageContext';

const StoreManagement = () => {
  let history = useHistory();
  const [dataa, setDataa] = React.useState([]);
  const { currentLangData } = React.useContext(LangContext);
  const [valueSearch, setValueSearch] = React.useState();
  const [value, setValue] = React.useState('10');
  const [paginat, setpaginate] = React.useState();
  const [loader, setLoader] = React.useState(false);
  const [success, setSuccess] = React.useState(null);
  let apimanager = ApiManager.getInstance();
  const toast = useToast();
  // Creating Variable //
  let tempArray = [];
  const handleOnChange = (evt, key) => {
    const ev = evt.target.value;
    setValue(ev);
  };
  const handleOnSearch = (evt, key) => {
    const ev = evt.target.value;
    setValueSearch(ev);
    searchItems(ev, value, 1);
  };
  React.useEffect(() => {
    getALLItems(value, 1);
  }, [value]);
  const getALLItems = (limit, page) => {
    setLoader(false);
    const body = {
      numRecords: limit,
      page: page,
    };
    apimanager
      .get('getAllStores', body)
      .then(res => {
        // console.log("res>>",res)
        if (res.message === 8250) {
          res?.record?.docs?.map((value, index) => {
            tempArray.push(value);
          });
          setDataa(tempArray);
          setpaginate(res?.record);
          setLoader(true);
        } else {
          toast({
            title: 'Something Went Wrong',
            status: 'error',
            duration: 3000,
            isClosable: true,
            description: `Something Went Wrong`,
          });
        }
        if (res.message === 8499) {
          toast({
            title: 'Something went wrong',
            status: 'error',
            duration: 3000,
            isClosable: true,
            description: 'Failed.Response Not saved',
          });
        }
        if (res.message === 7000) {
          toast({
            title: 'User Not Found',
            status: 'error',
            duration: 3000,
            isClosable: true,
            description: `User Not Found`,
          });
        }
      })
      .catch(error => {
        console.log('error', error);
        setLoader(true);
      });
  };
  const deleteItem = item => {
    console.log('Deletion done', item.id);
    let apimanager = ApiManager.getInstance();
    const body = {
      id: item._id,
    };
    console.log('body>>>>', body);
    apimanager
      .post('deleteStore', body)
      .then(response => {
        if (response.message === 8507) {
          setSuccess('Successfully Deleted!');
          toast({
            title: success,
            status: 'success',
            duration: 3000,
            isClosable: true,
            description: `Deleted, Please processed to List!`,
          });
          getALLItems(value, 1);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };
  const searchItems = (value, limit, page) => {
    console.log('value');
    setLoader(false);
    const body = {
      searchPhrase: value,
      numRecords: limit,
      page: page,
    };
    console.log('body', body);
    apimanager
      .post('searchStore', body)
      .then(res => {
        console.log('res=>', res);
        if (res.message === 8512) {
          res?.result?.docs.map((value, index) => {
            tempArray.push(value);
          });
          setDataa(tempArray);
          setpaginate(res?.result);
          setLoader(true);
        }
      })
      .catch(error => {
        console.log('error', error);
        setLoader(true);
      });
  };
  return (
    <Flex flexDirection={'column'}>
      <Flex {...style.miniheader}>
        {MiniHeader({
          title: 'Stores List',
          path: 'Dashboard',
          onclickForRoute: () => history.push('/Dashboard'),
          path2: 'sidebar.selfCareCenterManagement',
        })}
      </Flex>
      <Flex {...style.box} background={'#fafdfb'} padding={10}>
        <Flex {...style.main}>
          <Flex {...style.buttoncontainer}>
            <Button
              {...style.createbutton}
              onClick={() => history.push('/CreateStore')}
            >
              Create
            </Button>
            <Button
              {...style.bulkbutton}
              onClick={() => history.push('/AddBulk')}
            >
              Add Bulk
            </Button>
          </Flex>
          <Flex {...style.optionFlex}>
            <Flex {...style.showentries} alignItems={'center'} fontSize={'sm'}>
              <Text>{currentLangData?.app?.show}</Text>
              <Select
                {...style.select}
                onChange={e => handleOnChange(e, 'numrecords')}
              >
                {options.map(option => (
                  <option value={option.value}>{option.label}</option>
                ))}
              </Select>
              <Text>{currentLangData?.app?.entries}</Text>
            </Flex>
            <Spacer />
            <Flex alignItems={'center'} {...style.showentries}>
              <Text paddingY={'5px'}>{currentLangData?.app?.search}:</Text>
              {customInputLabel({
                size: 'sm',
                onChange: e => handleOnSearch(e, 'searchPhrase'),
              })}
            </Flex>
          </Flex>
          <ChecktableTwo
            datalist={dataa}
            TotDocs={paginat}
            loaderr={loader}
            headerNames={colStoreManagement}
            onPageChange={page => {
              if (valueSearch) {
                searchItems(valueSearch, value, page);
              } else {
                getALLItems(value, page);
              }
            }}
            renderItem={({ item, index }) => {
              console.log('renderitem', item);
              return (
                <Tr key={index} width={'100%'}>
                  {item?.storeType === 1 ? (
                    <Td>
                      <Text>SELFCARE</Text>
                    </Td>
                  ) : (
                    <Td>
                      <Text>AD/MD</Text>
                    </Td>
                  )}
                  <Td>{item?.branch}</Td>
                  <Td>{item?.contact}</Td>
                  <Td
                    position={'relative'}
                    display={'inline-flex'}
                    verticalAlign={'middle'}
                  >
                    <Tooltip label={currentLangData?.app?.edit}>
                    <Button
                      {...style.editbtn}
                      leftIcon={<EditIcon />}
                      onClick={() =>
                        history.push({
                          pathname: '/CreateStore',
                          status: 'create',
                          state: { val: item },
                        })
                      }
                    >
                    </Button>
                    </Tooltip>
                    <Tooltip label={currentLangData?.app?.delete} bg={'red'}>
                    <Button
                     {...style.Delbtn} 
                     leftIcon={<DeleteIcon />}
                     onClick={() => deleteItem(item)}>
                    </Button>
                    </Tooltip>
                  </Td>
                </Tr>
              );
            }}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};
export default StoreManagement;
